import ReactJoyride from "react-joyride";
import { ONBOARDING_STATE } from "../core/constants";
import { getOnboardingLocale } from "../core/i18n";
import { getDomainCfg, store } from "../core/state";
import { dissmissOnboarding, getJourneySteps, nextJourneyAvailable, setCurrentJourneyFinished, setCurrentOnboardingStep } from "../features/onboarding";
import { useEffect } from "react";
import { getComponentData, setComponentData } from "../core/views";
import { on } from "events";

export const hideOnboarding = () => {
  const onboarding = getComponentData(ONBOARDING_STATE);
  const newOnboarding = { ...onboarding,
    run : false

  };
  setComponentData(ONBOARDING_STATE, newOnboarding);
  //setCurrentJourneyFinished(onboarding.currentStep);
}

export const showOnboarding = () => {
  const onboarding = getComponentData(ONBOARDING_STATE);
  const newOnboarding = { ...onboarding,
    run : true
  };
  setComponentData(ONBOARDING_STATE, newOnboarding);
  //setCurrentJourneyFinished(onboarding.currentStep);
}

export const Onboarding = (props : {view : string }) => {
  const [onboarding] = store.useState(ONBOARDING_STATE);
  
  const changed = (joyrideState) => {
    console.log('ONBOARDING: onboarding changed:', joyrideState)
    if (joyrideState.lifecycle === "complete") {
      if (joyrideState.action === "next" && joyrideState.status === "finished") {
        console.log('ONBOARDING: close onboarding action next');
        dissmissOnboarding();
      }
      if (joyrideState.action === "close") {
        console.log('ONBOARDING: close onboarding');
        dissmissOnboarding();
      }
      console.log('ONBOARDING: finished mainStep', onboarding.currentStep)
      setCurrentJourneyFinished(onboarding.currentStep);
    }
  }

  const currentSteps = getJourneySteps(onboarding.currentStep, props.view);
  useEffect(() => {
    if (onboarding.currentStep < 0) return;
    if (nextJourneyAvailable(props.view)) {
      console.log('ONBOARDING: activate next journey', onboarding);
      setCurrentOnboardingStep(onboarding.currentStep + 1);
    }
  
    //if (onboarding?.currentView !== props.view) return null;
    // used https://docs.react-joyride.com/
  
    
    if (currentSteps.length === 0 && onboarding.currentStep > onboarding.lastFinishedStep) {
      setCurrentJourneyFinished(onboarding.currentStep);
    }
    console.log('ONBOARDING: show onboarding:', currentSteps);
  }, [onboarding]);

  if (!getDomainCfg().viewSettings.features.hasOnboarding) return null;
  console.log('ONBOARDING: render onboarding:', currentSteps, onboarding);
  const onboardingComponent = <ReactJoyride run={onboarding.run} steps={currentSteps} spotlightClicks={true} continuous={true} locale={getOnboardingLocale()} hideBackButton={true} callback={changed}/>
  return onboardingComponent;
}
